var map = {
	"./acceptCheckMark.svg": 8810,
	"./answerCheckMark.svg": 3808,
	"./bg.jpg": 8496,
	"./bg_office.jpg": 5827,
	"./bg_office_small.jpg": 5617,
	"./congress1/answerCheckMark.svg": 7177,
	"./congress1/background.png": 3937,
	"./congress1/correct.svg": 6106,
	"./congress1/notCorrect.svg": 7559,
	"./congress1/partlyCorrect.svg": 2145,
	"./congress1/progressionRisk.jpg": 364,
	"./congress1/results1.jpg": 1332,
	"./congress1/results2.jpg": 9749,
	"./congress1/results2.png": 3169,
	"./congress1/results3.jpg": 6450,
	"./congress1/results3.png": 7669,
	"./congress1/results4.jpg": 837,
	"./congress1/results5.jpg": 6301,
	"./congress1/sec2_1_1.png": 2721,
	"./congress1/sec2_1_1old.jpg": 1788,
	"./congress1/sec2_1_2old.jpg": 1375,
	"./congress1/sec2_2_1.jpg": 1728,
	"./congress1/sec2_3_1.jpg": 9128,
	"./congress1/sec2_3_1.png": 7965,
	"./congress1/sec2_4_1.jpg": 9580,
	"./congress1/sec2_5_1.jpg": 1535,
	"./congress1/sec2_5_2.jpg": 7809,
	"./congress1/sec2_5_3.jpg": 5529,
	"./congress1/sec2_5_3.png": 6631,
	"./congress1/sec2_6_1.jpg": 1504,
	"./congress1/secbtn1_1.svg": 1474,
	"./congress1/secbtn1_2.svg": 1071,
	"./congress1/secbtn1_3.svg": 1329,
	"./congress1/secbtn1_4.svg": 1070,
	"./congress1/secbtn2_1.svg": 9488,
	"./congress1/secbtn2_2.svg": 2020,
	"./congress1/secbtn2_3.svg": 5763,
	"./congress1/secbtn2_4.svg": 9196,
	"./congress1/secbtn2_5.svg": 9884,
	"./congress1/secbtn2_6.svg": 4236,
	"./congress1/secbtn2_7.svg": 1366,
	"./congress1/secbtn2_8.svg": 5982,
	"./congress1/start1.png": 5731,
	"./cup.svg": 3129,
	"./ex_1.svg": 887,
	"./ex_2.svg": 2915,
	"./ex_3.svg": 7922,
	"./ex_4.svg": 3825,
	"./game1/sec1_1_1.jpg": 9162,
	"./game1/sec1_1_2.jpg": 4554,
	"./game1/sec1_4_1.jpg": 6463,
	"./game1/sec1_4_2.jpg": 5780,
	"./game1/sec1_4_3.jpg": 584,
	"./game1/sec1_4_4.jpg": 1214,
	"./game1/sec2_2_1.jpg": 8088,
	"./game1/sec2_3_1.jpg": 2677,
	"./game1/sec2_3_2.jpg": 9691,
	"./game10/analysis1.png": 7650,
	"./game10/analysis2.png": 5648,
	"./game10/analysis3.png": 1085,
	"./game10/analysis4.png": 8828,
	"./game10/analysis5.png": 4523,
	"./game10/analysis6.png": 3217,
	"./game11/analysis1.png": 3106,
	"./game11/analysis2.png": 1715,
	"./game11/analysis3.png": 8120,
	"./game11/analysis4.png": 1653,
	"./game11/analysis5.png": 7798,
	"./game11/analysis6.png": 6356,
	"./game11/sec2_3_1.jpg": 314,
	"./game12/analysis1.png": 7636,
	"./game12/analysis2.png": 8006,
	"./game12/analysis3.png": 7890,
	"./game12/analysis4.png": 504,
	"./game12/analysis5.png": 7033,
	"./game12/analysis6.png": 8245,
	"./game12/analysis7.png": 8531,
	"./game12/analysis8.png": 4751,
	"./game2/analysis1.png": 8672,
	"./game2/sec1_3_1.png": 93,
	"./game2/sec1_4_1.png": 9640,
	"./game2/sec2_3_1.png": 7752,
	"./game3/analysis1.png": 6435,
	"./game3/analysis2.png": 5146,
	"./game3/analysis3.png": 4226,
	"./game3/analysis4.png": 1846,
	"./game3/analysis5.png": 9730,
	"./game3/analysis6.png": 4461,
	"./game3/sec2_2_1.png": 6437,
	"./game3/sec2_3_1.png": 1611,
	"./game3/sec2_4_1.png": 7191,
	"./game4/sec1_4_1.jpg": 6344,
	"./game4/sec2_3_1.jpg": 5807,
	"./game5/sec2_3_1.jpg": 4369,
	"./game5/sec2_3_2.jpg": 2163,
	"./game7/analysis1.jpg": 4798,
	"./game7/sec2_3_1.jpg": 1825,
	"./game7/sec2_3_2.jpg": 8826,
	"./game7/sec2_3_3.jpg": 6745,
	"./game8/sec1_4_1.jpg": 1219,
	"./game8/sec1_4_2.jpg": 511,
	"./game8/sec1_4_3.jpg": 4884,
	"./game8/sec2_3_1.jpg": 828,
	"./game8/sec2_3_2.jpg": 6468,
	"./game9/sec1_4_1.jpg": 5925,
	"./game9/sec1_4_2.jpg": 2238,
	"./game9/sec1_4_3.jpg": 7749,
	"./game9/sec2_3_1.jpg": 4860,
	"./game9/sec2_3_2.jpg": 7447,
	"./game9/sec2_3_3.jpg": 858,
	"./game9/sec2_4_1.jpg": 8818,
	"./star.svg": 3111,
	"./star_full.svg": 3632,
	"./ts_1.svg": 3641,
	"./ts_2.svg": 5750,
	"./ts_3.svg": 9160,
	"./ts_4.svg": 4858,
	"./ts_5.svg": 8225,
	"./ts_6.svg": 426,
	"./ts_7.svg": 3292
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;